export default "__VITE_ASSET__CJV6hN6d__"